import { render, staticRenderFns } from "./BaseActionIcon.vue?vue&type=template&id=4496b391"
import script from "./BaseActionIcon.vue?vue&type=script&lang=js"
export * from "./BaseActionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports